import { useQuery, keepPreviousData } from '@tanstack/react-query'
import { ActivityLog } from '../../shared/types'
import { get } from '../fetch'

export function useActivityLogsList(
	objectType: string,
	objectId: string,
	{ action, page }: { action?: string; page?: number } = {},
) {
	return useQuery({
		queryKey: ['api/activity-logs', objectType, objectId, { action, page }],
		queryFn: () => {
			const searchParams = new URLSearchParams()
			searchParams.append('objectType', objectType)
			searchParams.append('objectId', objectId)
			if (page) {
				searchParams.append('page', String(page))
			}
			if (action) {
				searchParams.append('action', action)
			}
			return get<{ total: number; list: ActivityLog[] }>(`/api/0/activity-logs`, searchParams)
		},
		placeholderData: keepPreviousData,
	})
}
